import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/credit-suisse-cop-hackathon-sept16/credit-suisse-cop-hackathon-sept16/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`On Microsoft Learn, you’ll find a lot of free `}<span>{`Learning Paths`}</span>{` around Microsoft and Open Source technology.
Many of them are aligned with professional `}<a parentName="p" {...{
          "href": "https://docs.microsoft.com/en-us/certifications/browse/?ocid=AID3054457"
        }}>{`Certifications`}</a></p>
    </PageDescription>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://docs.microsoft.com/en-us/certifications/exams/az-900?ocid=AID3054457"
          }}>{`AZ 900 - Azure Fundamentals`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://docs.microsoft.com/en-us/certifications/exams/dp-900?ocid=AID3054457"
          }}>{`DP 900 - Azure Data Fundamentals`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://docs.microsoft.com/en-us/certifications/exams/ai-900?ocid=AID3054457"
          }}>{`AI 900 - Azure AI Fundamentals`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://docs.microsoft.com/en-us/windows/mixed-reality/develop/mixed-reality-cloud-services?ocid=AID3054457"
          }}>{`Azure Mixed Reality Cloud Services Overview`}</a></p>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      